import React from "react"
import SelectGenericNew from "../../../../../gd-ui/select-generic-new/select-generic-new"
import {FieldAutomationConditionFormProps} from "../../../../render/automation-condition-form";

const debug = false
// const debug = "FieldDropdown_AutomationConditionForm"

export default class FieldDropdown_AutomationConditionForm extends React.Component<FieldAutomationConditionFormProps,any> {

    constructor(props:FieldAutomationConditionFormProps) {
        super(props)

        this.state = {
            value: _.get(props.config, 'value', null)
        }
    }

    onChangeToValue = (option:any) => {
        const value = option ? option.value : null

        this.setState({
            value
        }, ()=>{
            this.props.onChangeCallback({value})
        })
    }

    render() {
        debug && console.log(debug, 'render', this.state)

        const labelClasses = Classes("label", {
            'w-100': this.props.field.isCustom
        })

        return (
            <div className="flex-row-left-top">
                <div className={labelClasses}>is</div>
                <SelectGenericNew className                     = "selector w-180"
                                  options                       = {this.props.field.getAutomationOptions()}
                                  value                         = {this.state.value}
                                  popoverScrollContainerClasses = "max-h-200"
                                  noValueOption                 = {true}
                                  isSearchable                  = {true}
                                  disabled                      = {this.props.config.disabled}
                                  onChange                      = {this.onChangeToValue}/>
            </div>
        )
    }
}
